import React from 'react'
import { Container, Tab, Tabs } from 'react-bootstrap';
import ReactOwlCarousel from 'react-owl-carousel';
import { Link } from 'react-router-dom';
import { ImageUrl } from '../../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";

const CarouselSlide = () => (
    <ReactOwlCarousel className="owl-main owl-theme mt-5" 
        nav
        navText={['', '']}
        dots={false} 
        margin={30} 
        items={4}
        responsive={
            {0: {
                    center: true,
                    items: 3,
                    nav: false
                },
            450: {
                    center: false,
                    items: 3,
                    nav: false
                    },
            992: {
                    center: false,
                    items: 3,
                    nav: false
                    },
            1024: {
                    center: false,
                    items: 4,
                    nav: true
                    }
                }
        }  
        loop>
            <div className='item text-center'>
                <Link to="diamonds/shape=Asscher"><LazyLoadImage src={`${ImageUrl}theme/newyork/product/F1624.jpg`} alt='' /></Link>

                <div className='content position-relative'> 
                    <Link>
                        <p className='m-0'>14K White Gold Solitaire Princess Shape Diamond Engagement Ring</p>
                        <p>$489</p>
                    </Link>
                </div>
            </div>

            <div className='item text-center'>
                <Link to="diamonds/shape=Cushion"><LazyLoadImage src={`${ImageUrl}theme/newyork/product/F1626.jpg`} alt='' /></Link>

                <div className='content position-relative'> 
                    <Link to="diamonds/shape=Cushion">
                        <p className='m-0'>14K White Gold Solitaire Emerald Shape Diamond Engagement Ring</p>
                        <p>$489</p>
                    </Link>
                </div>
            </div>

            <div className='item text-center'>
                <Link to="diamonds/shape=Emerald"><LazyLoadImage src={`${ImageUrl}theme/newyork/product/F1627.jpg`} alt='' /></Link>

                <div className='content position-relative'> 
                    <Link to="diamonds/shape=Emerald">
                        <p className='m-0'>14K White Gold Solitaire Oval Shape Diamond Engagement Ring</p>
                        <p>$489</p>
                    </Link>
                </div>
            </div>

            <div className='item text-center'>
                <Link to="diamonds/shape=Heart"><LazyLoadImage src={`${ImageUrl}theme/newyork/product/F1628.jpg`} alt='' /></Link>

                <div className='content position-relative'>
                    <Link to="diamonds/shape=Emerald">
                        <p className='m-0'>14K White Gold Solitaire Marquise Shape Diamond Engagement Ring</p>
                        <p>$489</p>
                    </Link>
                </div>
            </div>

            <div className='item text-center'>
                <Link to="diamonds/shape=Marquise"><LazyLoadImage src={`${ImageUrl}theme/newyork/product/F1623.jpg`} alt='' /></Link>

                <div className='content position-relative'>
                    <Link>
                        <p className='m-0'>14K White Gold Solitaire Cushion Shape Diamond Engagement Ring.</p>
                        <p>$489</p>
                    </Link>
                </div>
            </div>

        </ReactOwlCarousel>
)

const BestSellingProduct = () => {
  return (
    <>
        <div className='best_selling_product'>
            <Container>
                <div className="title-box text-center pb-4">
                    <h2>BEST SELLING PRODUCTS</h2>
                    <LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/line-black.png`} alt="" />
                </div>

                <Tabs defaultActiveKey="engagement_ring" id="uncontrolled-tab-example" className="mb-3">
                    <Tab eventKey="engagement_ring" title="Engagement Ring">
                        <CarouselSlide />
                    </Tab>
                    <Tab eventKey="wedding_ring" title="Wedding Ring">
                        <CarouselSlide />
                    </Tab>
                    <Tab eventKey="earring" title="Earring">
                        <CarouselSlide />
                    </Tab>
                    <Tab eventKey="bracelet" title="Bracelets">
                        <CarouselSlide />
                    </Tab>
                    <Tab eventKey="necklace" title="Necklace">
                        <CarouselSlide />
                    </Tab>
                </Tabs>
            </Container>
        </div>
    </>
  )
}

export default BestSellingProduct;